import styled, { css } from 'styled-components';
import { Col, Row } from 'components/Styled/Basic';

export const Box = styled(Row)`
    background: #fff;
    position: relative;
    transition: all 0.5s;
    border-radius: 3px;
    box-shadow: 0 0 3px 0 rgba(0, 0, 0, 0.02), 0 0 2px 0 rgba(0, 0, 0, 0.04);
`;

Box.defaultProps = {
	margin: '5px',
	padding: '10px',
};

export const BoxCol = styled(Box)`
	flex-direction: column;
`;

BoxCol.defaultProps = {
	margin: '5px',
	padding: '0',
};

export const PageBox = styled(Col)`
	box-sizing: border-box;
    flex: 1;
	padding: 5px;
    overflow-y: auto;
	width: calc(100vw - 50px);
	
	${({ hidden }) => hidden && css`
		display: none !important;
	`}
`;
